module.exports = __webpack_public_path__ + "img/infibo-how-to-buy-a-license-ru-2.4dfc021c.png";